import { AxiosError } from 'axios';

import { apiInstance as api } from './api-instance';
import { CompatibilityPayload } from './types/compatibility.dto';

export const updateProfile = async <T extends object>({
  land,
  step,
  topicType,
  topic,
  answer,
  guestId,
}: {
  land: string;
  step: string;
  topicType: string;
  topic: string;
  answer: T | string | number;
  guestId?: string;
}) => {
  const body = {
    innerId: `land_${land}_${step}`,
    type: topicType,
    topic: topic,
    answer: answer,
  };

  const config = guestId
    ? {
        headers: {
          'Guest-Authorization': `Bearer ${guestId}`,
        },
      }
    : undefined;
  api.post('profile/onboarding', body, config).catch((error: AxiosError) => {
    console.error(error.message);
  });
};

export const createCompatibility = (payload: CompatibilityPayload) => {
  return api.post('compatibility/full', payload).catch((error: AxiosError) => {
    console.error(error.message);
  });
};

export const getGeoVariants = async <T extends { address: string }>(
  userPlace: string
): Promise<T[]> => {
  return api
    .post(`geo/search/${userPlace}`)
    .then((response) => response.data)
    .catch((error: AxiosError) => {
      console.error('Request geo failed', error.message);
    });
};
